// extracted by mini-css-extract-plugin
export default {"wrapper":"PhoneVerificationModal_wrapper__MTI1l"};